import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Pagination } from "@mui/material";
import services from "../../services/services";
import AppPurchasesTable from "../../component/appPurchasesTable/AppPurchasesTable";

const AppPurchases = () => {
  const { adminPermission } = useSelector((state: any) => state.counter);
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [platform, setPlatform] = useState<"all" | "ios" | "android">("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const pageLimit = 15;

  const fetchRows = async (pageNo: number, search: string, plat: "all" | "ios" | "android") => {
    setLoading(true);
    try {
      const res = await services.getAppPurchases({
        page: pageNo,
        limit: pageLimit,
        search,
        platform: plat,
      });
      const { data, pagination } = res.data;
      setRows(data || []);
      setTotalPages(pagination?.totalPages || 1);
      setTotalItems(pagination?.totalItems || 0);
    } catch (error) {
      console.error("Error fetching app purchases:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRows(1, searchTerm, platform);
    setCurrentPage(0);
  }, [searchTerm, platform]);

  const handleSearch = () => {
    setSearchTerm(searchInput);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSearch();
  };

  const handleClearSearch = () => {
    setSearchInput("");
    setSearchTerm("");
  };

  const handlePageClick = ({ selected }: { selected: number }) => {
    setCurrentPage(selected);
    fetchRows(selected + 1, searchTerm, platform);
  };

  if (adminPermission?.is_admin == 2 && !adminPermission?.appPurchases) {
    return (
      <h1 className="text-3xl font-openSans font-bold text-aqua items-center flex justify-center h-[80vh]">
        You don't have permission
      </h1>
    );
  }

  return (
    <div>
      <div className="flex px-12 w-full justify-between items-center mt-4 flex-wrap gap-4">
        <div className="flex items-center gap-2 flex-wrap">
          <input
            type="text"
            placeholder="Search by email, order ID, or product..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={handleKeyDown}
            className="border border-gray-300 rounded-md px-4 py-2 w-80 outline-none focus:border-aqua"
          />
          <button
            onClick={handleSearch}
            className="bg-aqua text-white px-4 py-2 rounded-md font-openSans"
          >
            Search
          </button>
          {searchTerm && (
            <button
              onClick={handleClearSearch}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md font-openSans"
            >
              Clear
            </button>
          )}
        </div>

        <div className="flex items-center gap-3">
          <label className="text-sm font-openSans text-gray-600">Platform</label>
          <select
            value={platform}
            onChange={(e) => setPlatform(e.target.value as any)}
            className="border border-gray-300 rounded-md px-3 py-2 outline-none focus:border-aqua bg-white"
          >
            <option value="all">All</option>
            <option value="ios">iOS</option>
            <option value="android">Android</option>
          </select>
          <span className="text-sm font-openSans text-gray-500">
            {totalItems} total
          </span>
        </div>
      </div>

      {loading ? (
        <div className="flex w-full justify-center mt-8">
          <h1 className="text-aqua text-3xl">Loading...</h1>
        </div>
      ) : (
        <div className="mt-6 px-12">
          {rows.length ? (
            <AppPurchasesTable rows={rows} />
          ) : (
            <div className="w-full h-[20vh] flex justify-center items-center">
              <h2 className="text-center text-aqua font-bold font-openSans w-full text-4xl">
                No App Purchases Found
              </h2>
            </div>
          )}
        </div>
      )}

      {rows.length !== 0 && (
        <div className="flex justify-center mt-6 mb-6">
          <Pagination
            count={totalPages || 1}
            page={currentPage + 1}
            onChange={(event, page) => handlePageClick({ selected: page - 1 })}
            siblingCount={3}
            boundaryCount={2}
            variant="outlined"
            shape="rounded"
            size="large"
            color={"primary"}
          />
        </div>
      )}
    </div>
  );
};

export default AppPurchases;
